import { Container, Spinner, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import { DirectToBank } from 'payment-react-component';
import * as React from 'react';

import DelayedLoader from '../components/common/DelayedLoader';
import NoticeWithButton from '../components/common/NoticeWithButton';
import InfoNotice from '../components/invoice/notices/InfoNotice';
import SuccessNotice from '../components/invoice/notices/SuccessNotice';
import config from '../config';
import ZebraPadding from '../components/common/ZebraPadding';
import { RouteService } from '../services/RouteService';
import { DirectPaymentStore } from '../stores/DirectPaymentStore';
import { ILanguageStore } from '../stores/LanguageStore';
import { ITranslateStore } from '../stores/TranslateStore';

import DirectPaymentReturn from './DirectPaymentReturn';

interface IDirectPaymentProps {
  directPaymentStore?: DirectPaymentStore;
  translateStore?: ITranslateStore;
  languageStore?: ILanguageStore;
  routeService?: RouteService;
}

@inject('directPaymentStore', 'translateStore', 'languageStore', 'routeService')
@observer
export default class DirectPayment extends React.Component<IDirectPaymentProps> {
  public componentDidMount(): void {
    this.props.directPaymentStore.tryLoadBalance();
  }

  public renderContent(): JSX.Element {
    const directPaymentStore = this.props.directPaymentStore;
    const translate = this.props.translateStore.translate;
    const balance = directPaymentStore.balance;

    if (balance.isInitialLoading) {
      return <Spinner />;
    }

    if (balance.isFinishedWithError || balance.payload.validationResult === 'INVALID_MAC') {
      return this.warningNoticeWithButton(translate('direct-payment.errors.payment-link-invalid'));
    }

    if (balance.payload.validationResult === 'EXPIRED') {
      return this.warningNoticeWithButton(translate('direct-payment.errors.payment-link-expired'));
    }

    if (!directPaymentStore.hasUnsettledInvoices) {
      return <DirectPaymentReturn notification={<SuccessNotice translationKey="direct-payment.notices.all-paid" />} />;
    }

    return (
      <>
        <InfoNotice translationKey="direct-payment.notices.direct-to-bank" />
        <DelayedLoader delayMs={3000}>
          <DirectToBank
            referenceNumber={directPaymentStore.refNumber}
            amount={directPaymentStore.amountToPay}
            bankCode={directPaymentStore.bankCode}
            environment={config.paymentFrontendEnvironmentName}
            successUrl={directPaymentStore.successUrl}
            failedUrl={directPaymentStore.failedUrl}
            processingUrl={directPaymentStore.processingUrl}
            language={this.props.languageStore.currentLanguage}
            source="E_MAIL"
          />
        </DelayedLoader>
      </>
    );
  }

  public render(): JSX.Element {
    return <Text>{this.renderContent()}</Text>;
  }

  private warningNoticeWithButton(noticeText: string) {
    const translate = this.props.translateStore.translate;

    return (
      <ZebraPadding>
        <Container>
          <Text>
            <NoticeWithButton
              gaEvent="CTA - direct payment"
              noticeType="error"
              noticeText={noticeText}
              buttonProps={{
                iconRight: '#arrow-right',
                text: translate('shared.notices.login-required.login-button'),
                onClick: () => this.props.routeService.navigateToInvoicePage()
              }}
            />
          </Text>
        </Container>
      </ZebraPadding>
    );
  }
}
